import React, { useState, useEffect } from 'react';
import classes from '../Preguntas.css';

export default function PreguntaTexto({
  id,
  fraseSugerencia,
  numeroPregunta,
  onChangeRespuesta,
  esObligatoria,
  defaultValue = ''
}) {
  const [texto, setTexto] = useState(String(defaultValue || ''));

  // Actualiza si defaultValue cambia
  useEffect(() => {
    const nuevoValor = String(defaultValue || '');
    if (nuevoValor !== texto) {
      setTexto(nuevoValor);
    }
  }, [defaultValue]);

  const handleTextoChange = (event) => {
    setTexto(event.target.value);
  };

  useEffect(() => {
    const respuesta = {
      numeroPregunta,
      tieneContenido: texto.trim() !== '',
      contenido: [numeroPregunta, texto],
      esObligatoria
    };
    onChangeRespuesta(respuesta);
  }, [texto]);

  return (
    <textarea
      id={id}
      className={classes.texto}
      placeholder={(fraseSugerencia || '').trim() || 'Contanos lo que quieras…'}
      value={texto}
      onChange={handleTextoChange}
    />
  );
}
